module.exports = __webpack_public_path__ + "24e004ab/img/boston-lights.a623432f.png";